import { testimonialsList } from '@/constants/careers'

import Slider from '../slider'
import VideoModal from './VideoModal'

const Testimonials = () => {
  return (
    <div className="mt-6 sm:mt-12 lg:mt-[100px] flex items-center flex-wrap md:flex-nowrap bg-[#F9F6EC]">
      <Slider
        slidesToShowDesktop={3}
        slidesToShowTablet={2}
        slidesToScrollTablet={1}
        slidesToShowMobile={1}
        containerStyles="sm:gap-10"
      >
        {testimonialsList.map((testimonal, index) => (
          <VideoModal
            {...testimonal}
            key={index}
            imageStyles="h-[288px] lg:max-h-[300px] lg:max-w-[340px] rounded-2xl"
          />
        ))}
      </Slider>
    </div>
  )
}

export default Testimonials
